import { FC, ReactNode } from 'react'

import { InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material'

export type SelectMenuProps<T> = {
  label: ReactNode
  value: T | ''
  onChange: (event: SelectChangeEvent<T | ''>) => void
  options: SelectMenuOption<T | ''>[]
  disabled?: boolean
  required?: boolean
  autoWidth?: boolean
  /** Outlines the field in the theme warning colour, for a value that needs the user's attention. */
  warning?: boolean
}

export type SelectMenuOption<T> = {
  name: ReactNode
  value: T
  disabled?: boolean
  /** Renders the option in the theme error colour in the open list. */
  danger?: boolean
}

type SelectMenuType<T = any> = FC<SelectMenuProps<T>>

export const SelectMenu: SelectMenuType = ({ label, value, onChange, options, disabled, required, autoWidth = true, warning }) => {
  return (
    <>
      <InputLabel required={required} sx={warning ? { color: 'warning.main', '&.Mui-focused': { color: 'warning.main' } } : undefined}>
        {label}
      </InputLabel>
      <Select
        required={required}
        onChange={onChange}
        size="small"
        value={value}
        label={label}
        disabled={disabled}
        autoWidth={autoWidth}
        sx={
          warning
            ? {
                '& .MuiOutlinedInput-notchedOutline, &:hover .MuiOutlinedInput-notchedOutline, &.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'warning.main',
                },
              }
            : undefined
        }
      >
        {options.map((option) => (
          <MenuItem value={option.value} key={option.value} disabled={option.disabled} sx={option.danger ? { color: 'error.main' } : undefined}>
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </>
  )
}
